import Model, {
  attr,
  belongsTo,
  hasMany,
  type SyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company';
import type SupplierModel from './supplier';
import type UserModel from './user';
import type OrderEntryModel from './order-entry';
import { createHTMLProps, htmlType } from 'bcl/misc/decorators';
import { tracked } from '@glimmer/tracking';
import type LocationModel from './location';

@createHTMLProps
export default class OrderModel extends Model {
  declare [Type]: 'order';
  @belongsTo('supplier', { async: false, inverse: 'orders' })
  declare supplier: SupplierModel;
  @htmlType('date')
  @attr('date')
  declare delivery_date?: Date;
  @htmlType('date')
  @attr('date')
  declare accepted_date?: Date;
  @belongsTo('user', { async: false, inverse: null })
  declare created_by: UserModel;
  @belongsTo('user', { async: false, inverse: null })
  declare accepted_by: UserModel;
  @belongsTo('location', { async: false, inverse: null })
  declare delivered_to: LocationModel;
  @attr()
  declare delivered_as_expected?: boolean;
  @attr()
  declare note: string;
  @attr()
  declare status: string;
  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @attr()
  declare created_at: string;
  @attr()
  declare updated_at: string;

  @hasMany('order-entry', { async: false, inverse: 'order' })
  declare orderEntries: SyncHasMany<OrderEntryModel>;

  get isSpecial() {
    return (
      this.orderType === 'special' || this.supplier.additional === 'special'
    );
  }

  @tracked declare orderType: string;
}
